export { default } from './collection-mechanic';
